import { useQuery } from '@apollo/client';
import { Nullable, SelectOption } from 'global';

import { VOFilterType } from '../../filters';
import { opportunitiesListApi } from './index';

interface Response {
  voFilterOptions: {
    list: Array<SelectOption & { meta: { color: Nullable<string>; locationCategory: Nullable<string> } }>;
  };
}

interface Variables {
  input: {
    filterType: VOFilterType;
  };
}

export function useFilterOptions(filterType: VOFilterType) {
  const { data, previousData, loading, error } = useQuery<Response, Variables>(opportunitiesListApi.getFilterOptions, {
    fetchPolicy: 'cache-and-network',
    variables: {
      input: {
        filterType,
      },
    },
  });

  return {
    error,
    loading,
    options: previousData?.voFilterOptions?.list ?? data?.voFilterOptions?.list ?? [],
  };
}
